import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';

export const OTCBottomCardSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-left: auto;
  margin-right: auto;
  width: 100%;
  text-align: center;

  padding: ${props => props.theme.space['2.0']} ${props => props.theme.space['2.0']}
    ${props => props.theme.space['1.0']} ${props => props.theme.space['2.0']};
  margin-top: ${props => props.theme.space['2.0']};

  ${props => props.theme.mediaQueries.smallDown} {
    width: 100%;
    padding-left: ${props => props.theme.space['1.0']};
    padding-right: ${props => props.theme.space['1.0']};
    margin-bottom: ${props => props.theme.space['7.0']};
  }
`;

export const OTCChatTitle = styled.p`
  text-align: center;

  color: ${props => props.theme.colors.capsuleBlue50} !important;

  padding-top: ${props => props.theme.space['0.5']} !important;
  padding-bottom: ${props => props.theme.space['0.5']} !important;
  font-style: normal !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.bold} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;
  line-height: ${props => props.theme.space.s5} !important;
`;

export const OTCCardButtonSection = styled.div`
  margin-right: auto;
  margin-left: auto;

  padding-top: ${props => props.theme.space['0.5']} !important;
  padding-bottom: ${props => props.theme.space['0.5']} !important;
`;

export const OTCCardButton = styled(Button)`
  background: none !important;
  margin-right: auto;
  margin-left: auto;

  min-height: ${props => props.theme.space.none} !important;
  padding: ${props => props.theme.space['0.5']} ${props => props.theme.space['1.0']} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;
`;
